export default "__VITE_ASSET__4815be76__"